(function($, w, undefined) {

    function OurPartners(args) {
        this.defaults = {
            parent: '',
            swiperContainer: '',
            animationEffect: 'slide',
            swiperNextButton: '.swiper-next',
            swiperPrevButton: '.swiper-prev'
        };

        this.options = $.extend(true, {}, this.defaults, args);

        this.$parent = $(this.options.parent);
        this.$swiperContainer = this.parent(this.options.swiperContainer);

        this.$swiperNextButton = this.parent(this.options.swiperNextButton);
        this.$swiperPrevButton = this.parent(this.options.swiperPrevButton);


        this.swiper = null;
        this.initSwiper();

        if (!this.$swiperNextButton) {
            return;
        }

        if (!this.$swiperPrevButton) {
            return;
        }

        this.bindEvents();
    }


    OurPartners.prototype.parent = function(selector) {
        return $(selector, this.$parent);
    };

    OurPartners.prototype.initSwiper = function (){
        var self = this;

        this.swiper = new Swiper(this.$swiperContainer, {
            direction: 'horizontal',
            loop: false,
            effect: this.options.animationEffect,
            allowTouchMove: this.options.allowTouch,
            speed: 400,
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            autoplay: {
                delay: 5000
            },

            breakpoints: {
                // when window width is >= 320px
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 2,
                    allowTouchMove: this.options.allowTouchInDesktop
                }
            }
        });

      
    };

    OurPartners.prototype.bindEvents = function () {
        var self = this;

        this.$swiperNextButton.on("click", function () {
            self.swiper.slideNext();    
        });

        this.$swiperPrevButton.on("click", function () {
            self.swiper.slidePrev();
        });
    };


    w.MCN = w.MCN || {};
    w.MCN.OurPartners = OurPartners;

})(jQuery, window);
